import { render, staticRenderFns } from "./CreateServiceProvidersStructure.vue?vue&type=template&id=519e88df&scoped=true&"
import script from "./CreateServiceProvidersStructure.vue?vue&type=script&lang=js&"
export * from "./CreateServiceProvidersStructure.vue?vue&type=script&lang=js&"
import style0 from "./CreateServiceProvidersStructure.vue?vue&type=style&index=0&id=519e88df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e88df",
  null
  
)

export default component.exports